import { postApi } from '../api/digitalVault';
import { parsePlaylists } from '../utils';
export default async ({ name, type, repositoryPaths = [] }, logger) => {
    const data = {
        playlistDefinition: {
            '@xmlns': {
                $: 'http://playlist.dv.newbay.com/ns/1.0',
                a: 'http://alternate.newbay.com/ns/1.0',
            },
            name: { $: name },
            type: { $: type },
            repositoryPath: repositoryPaths.map((p) => ({
                $: p,
            })),
        },
    };
    const { playlistDefinition } = await postApi(data, 'playlist', {}, logger);
    const [playlist] = await parsePlaylists(playlistDefinition, false);
    return playlist;
};
